module.exports = __webpack_public_path__ + "static/media/business.c278f514.svg";